import { fetchApi } from '@/services/api-client';

import type { WalletTransactionItem, WalletTransactionType } from './wallet';

// Admin-oversight aggregate reads — distinct from the per-user `wallet/:userId`
// endpoints in `wallet.ts`. Server-side role can be any UserRole (including
// `parent`) or null if the linked user record is gone, so keep this union
// separate from the staff-login `Role` type in `@/lib/auth-context`.
export type WalletAccountRole = 'admin' | 'teacher' | 'student' | 'parent' | 'employee';

export interface WalletAccountSummary {
  userId: string;
  name: string;
  role: WalletAccountRole | null;
  balance: number;
  personId: string | null;
}

export interface WalletsOverview {
  totalBalance: number;
  accounts: WalletAccountSummary[];
}

export interface GlobalTransaction {
  id: string;
  userId: string;
  userName: string;
  type: WalletTransactionType;
  /** Signed integer baht: positive = credit, negative = debit. */
  amount: number;
  note: string;
  items: WalletTransactionItem[];
  performedById: string;
  createdAt: string;
}

export interface GlobalTransactionsFilters {
  type?: WalletTransactionType;
  limit?: number;
}

const BASE = '/admin/cafeteria/wallets';

export const walletsOverviewApi = {
  list: () => fetchApi<WalletsOverview>(BASE),
  transactions: (filters: GlobalTransactionsFilters = {}) => {
    const params = new URLSearchParams();
    if (filters.type) params.append('type', filters.type);
    if (filters.limit !== undefined) params.append('limit', String(filters.limit));
    const qs = params.toString();
    return fetchApi<GlobalTransaction[]>(`${BASE}/transactions${qs ? `?${qs}` : ''}`);
  },
};
